<template>

    <div class="spinner-overlay">
        <transition name="fade" mode="out-in">
            <div class="spinner-wrapper" v-if="!error" key="spinner">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Загрузка...</span>
                </div>
            </div>
            <div class="spinner-error" v-else>
                <error403 v-if="error === 403"> </error403>
                <error404 v-else-if="error === 404"> </error404>
                <error500 v-else-if="error === 500"> </error500>
                <network-error v-else>
                    <template slot="message">
                        {{ error }}
                    </template>
                </network-error>
            </div>
        </transition>
    </div>

</template>

<script>
    import NetworkError from "../pages/Errors/NetworkError";
    import Error403 from "../pages/Errors/Error403";
    import Error404 from "../pages/Errors/Error404";
    import Error500 from "../pages/Errors/Error500";

    export default {
        name: "Spinner",
        components: {
            Error404,
            NetworkError,
            Error403,
            Error500
        },
        props: {
            name: { type: String },
            error: ''
        }
    }
</script>

<style scoped lang="scss">
    @import 'node_modules/bootstrap/scss/bootstrap.scss';

    .spinner-overlay {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(255, 255, 255, 0.6);

        z-index: 20;
    }

    .spinner-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .spinner-error {
        padding-top: 5em;
        min-height: 100%;
        background-color: $light;
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

</style>